import {post,get} from '../index'
export const getHome={
    getBanner(params) {
		return get('/banner/list', params)
	},
    getComment(params){
        return get('/comment/list',params)
    },
 
}


// WEBPACK FOOTER //
// ./src/api/http/home.js